import { useMemo } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { TabBar } from '../../components/Tabs';
import { useAuthStore } from '../../app/authStore';
import { NAV_ITEMS } from '../../app/nav';

interface ModuleTab {
  key: string;
  label: string;
}

/**
 * 多机管理模块的页签容器。
 *
 * 页签即路由，因此刷新/收藏/后退都保持一致状态；单机管理会把当前选中的机号
 * 带进 URL（`/fleet/tracking/:droneId`），切到别的页签再切回来时不会丢失选择。
 */
export function FleetLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = useAuthStore((state) => state.permissions);
  const params = useParams<{ droneId?: string }>();

  const tabs = useMemo<ModuleTab[]>(() => {
    const allowed = new Set(NAV_ITEMS.filter((item) => permissions.includes(item.permission)).map((item) => item.to));
    return [
      { key: '/fleet', label: '总览' },
      { key: '/fleet/drones', label: '无人机管理' },
      { key: '/fleet/tracking', label: '单机管理' },
    ].filter((tab) => allowed.has(tab.key));
  }, [permissions]);

  const active = useMemo(() => {
    if (location.pathname.startsWith('/fleet/drones')) return '/fleet/drones';
    if (location.pathname.startsWith('/fleet/tracking')) return '/fleet/tracking';
    return '/fleet';
  }, [location.pathname]);

  return (
    <div className="flex h-[calc(100dvh-3.5rem)] min-h-0 flex-col">
      <div className="shrink-0 bg-surface-1 px-3 pt-1">
        <TabBar
          items={tabs}
          value={active}
          onChange={(key) => {
            if (key === '/fleet/tracking' && params.droneId) {
              navigate(`/fleet/tracking/${params.droneId}`);
              return;
            }
            navigate(key);
          }}
        />
      </div>
      <div className="min-h-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
